import { render, staticRenderFns } from "./VxSelectItem.vue?vue&type=template&id=43afb872&lang=html&"
import script from "./VxSelectItem.vue?vue&type=script&lang=js&"
export * from "./VxSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports